import React, { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
//import { BsGearWide } from "react-icons/bs"
import { RiMessageLine, RiUserFollowLine, RiUserUnfollowLine } from "react-icons/ri"
import { FaRegBell } from "react-icons/fa"
import * as Components from "../exports"
import { useAuth } from "../context/AuthProvider"
import { timeAgo } from "../components/Time"
import defaultAvatar from "../assets/img/avatar.png"
import axios from "axios"
import { API_BASE } from "../config/api"
import "./Profile.css"

const mapPropertyToListing = (property) => ({
  id: property._id,
  image: (property.media || [])
    .map((m) => (typeof m === "string" ? m : m?.url))
    .filter(Boolean),
  price: `NGN ${Number(property.amount || 0).toLocaleString("en-NG")}`,
  location: [property.location?.town, property.location?.state].filter(Boolean).join(", "),
  category: property.property_type
    ? property.property_type.charAt(0).toUpperCase() + property.property_type.slice(1)
    : "",
})

const Profile = () => {
  const { user } = useAuth()
  const navigate = useNavigate();
  const { userId } = useParams(); // Get userId from URL if viewing another user
  const [isOwnProfile, setIsOwnProfile] = useState(true)
  const [isFollowing, setIsFollowing] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [activeTab, setActiveTab] = useState("listings")
  const [profileData, setProfileData] = useState(null)
  const [listings, setListings] = useState([])
  const [followersCount, setFollowersCount] = useState(0)
  const [followingCount, setFollowingCount] = useState(0)

  // Fetch profile data
  useEffect(() => {
    const loadProfile = async () => {
      setIsLoading(true)
      try {
        const viewingOwn = !userId || userId === "me"
        setIsOwnProfile(viewingOwn)

        let profileUser = null
        if (viewingOwn) {
          const token = localStorage.getItem("token")
          if (token) {
            const res = await axios.get(`${API_BASE}/profile`, {
              headers: { Authorization: `Bearer ${token}` },
            })
            profileUser = res.data.user || null
            setProfileData(profileUser)
            setFollowersCount(res.data.followersCount || 0)
            setFollowingCount(res.data.followingCount || 0)
          } else {
            profileUser = user || null
            setProfileData(profileUser)
            setFollowersCount(0)
            setFollowingCount(0)
          }
        } else {
          const token = localStorage.getItem("token")
          const headers = token ? { Authorization: `Bearer ${token}` } : {}
          const res = await axios.get(`${API_BASE}/users/${userId}`, { headers })
          profileUser = res.data.user || null
          setProfileData(profileUser)
          setFollowersCount(res.data.followersCount || 0)
          setFollowingCount(res.data.followingCount || 0)
          setIsFollowing(!!res.data.isFollowing)
        }

        const profileOwnerId = viewingOwn
          ? (profileUser?._id || profileUser?.id || user?._id || user?.id)
          : (profileUser?._id || profileUser?.id || userId)

        if (profileOwnerId) {
          try {
            const token = localStorage.getItem("token")
            const headers = token ? { Authorization: `Bearer ${token}` } : {}
            const res = await axios.get(`${API_BASE}/properties`, { headers })
            const ownedListings = (res.data.items || [])
              .filter((property) => String(property.owner?._id || property.owner || "") === String(profileOwnerId))
              .map(mapPropertyToListing)

            setListings(ownedListings)
          } catch (listingErr) {
            console.error("Failed to load profile listings:", listingErr)
            setListings([])
          }
        } else {
          setListings([])
        }
      } catch (err) {
        setProfileData(null)
        setListings([])
      } finally {
        setIsLoading(false)
      }
    }
    loadProfile()
  }, [userId, user])

  const handleFollow = () => {
    if (!userId) return
    const token = localStorage.getItem("token")
    if (!token) return
    const next = !isFollowing
    setIsFollowing(next)
    axios
      .post(
        `${API_BASE}/users/${userId}/follow`,
        { followed: next },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        setIsFollowing(!!res.data.isFollowing)
        setFollowersCount(res.data.followersCount || 0)
        setFollowingCount(res.data.followingCount || 0)
      })
      .catch(() => {
        setIsFollowing(!next)
      })
  }

  
  const handleMessage = () => {
    navigate("/inbox");
    // Jay: Open chat with this user (not going to be implemented anymore)
    // Walter: That's right, Pending till futher notice
  };

  const handleEditProfile = () => {
    navigate("/account/profile");
  };

  const handleUpgrade = () => {
    navigate("/account/subscription");
  };
   const handleListClick = (listingId) => {
    navigate(`/listing/${listingId}/order`)
   }

  if (isLoading) {
    return (
      <Components.PageSetup>
        <Components.Header
          backIcon={!isOwnProfile}
          pageTitle={<h2>Profile</h2>}
          icons={[
            { link: "/notifications", element: <FaRegBell /> }
          ]}
        />
        <div className="main-content">
          <div className="content">
            <div className="profile-loading">
              <div className="skeleton skeleton-profile-header"></div>
              <div className="skeleton skeleton-stats"></div>
            </div>
          </div>
        </div>
      </Components.PageSetup>
    )
  }

  if (!profileData) {
    return (
      <Components.PageSetup>
        <Components.Header
          backIcon={true}
          pageTitle={<h2>Profile</h2>}
        />
        <div className="main-content">
          <div className="content">
            <div className="profile-error">
              <h3>Profile not found</h3>
              <p>This user doesn't exist or has been removed.</p>
              <Components.ClickButton
                text="Go Back"
                onClick={() => navigate(-1)}
                variant="primary"
              />
            </div>
          </div>
        </div>
      </Components.PageSetup>
    )
  }

  return (
    <Components.PageSetup>
      <Components.Header
        backIcon={!isOwnProfile}
        pageTitle={<h2>{isOwnProfile ? "My Profile" : profileData.fullName}</h2>}
        icons={
          isOwnProfile ? [
            { link: "/inbox", element: <RiMessageLine /> },
            { link: "/notifications", element: <FaRegBell /> }
          ] : [
            { link: "/notifications", element: <FaRegBell /> }
          ]
        }
        //menuIcon={isOwnProfile ? { element: <BsGearWide />, link: "/account" } : null}
      />
      
      <div className="main-content">
        <div className="content">
          {/* Profile Header Card */}
          <Components.AccountInfoCard
            username={profileData.username ? `@${profileData.username}` : ""}
            fullName={profileData.fullName}
            //occupation={profileData.occupation}
            followers={followersCount}
            email={profileData.email}
            plan={profileData.plan}
            avatar={profileData.avatar || defaultAvatar}
            verified={profileData.kycStatus === "verified"}
            bio={profileData.bio}
            yearJoined={timeAgo(profileData.createdAt)}
            isOwner={isOwnProfile}
            isFollowing={isFollowing}
            onEditProfile={handleEditProfile}
            onUpgrade={handleUpgrade}
            onFollow={handleFollow}
            onMessage={handleMessage}
          />

          {/* Stats */}
          <Components.ListStats
            listings={listings}
            followers={followersCount}
            following={followingCount}
            joinedAt={profileData?.createdAt}
          />

          {/* Tabs Navigation */}
          <div className="profile-tabs">
            <button
              className={`profile-tab ${activeTab === "listings" ? "active" : ""}`}
              onClick={() => setActiveTab("listings")}
            >
              Listings ({listings.length})
            </button>
            <button
              className={`profile-tab ${activeTab === "reviews" ? "active" : ""}`}
              onClick={() => setActiveTab("reviews")}
            >
              Reviews
            </button>
            <button
              className={`profile-tab ${activeTab === "about" ? "active" : ""}`}
              onClick={() => setActiveTab("about")}
            >
              About
            </button>
          </div>

          {/* Tab Content */}
          <div className="profile-tab-content">
            {activeTab === "listings" && (
              <div className="profile-listings">
                {listings.length > 0 ? (
                  <div className="listings-grid">
                    {listings.map((listing) => (
                      <div key={listing.id} className="listing-grid-item" onClick={() => handleListClick(listing.id)}>
                        <img src={listing.image[0] || (
                          <div className="property-image-placeholder" aria-hidden="true">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                              <rect x="3" y="3" width="18" height="18" rx="2"/>
                              <circle cx="8.5" cy="8.5" r="1.5"/>
                              <polyline points="21 15 16 10 5 21"/>
                            </svg>
                          </div>
                        )} alt="Property" />
                        <div className="listing-grid-info">
                          <h4 className="listing-price">{listing.price || 0}</h4>
                          <p className="listing-location">{listing.location}</p>
                          <span className="listing-category">{listing.category}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="profile-empty">
                    <p>No listings yet</p>
                  </div>
                )}
              </div>
            )}

            {activeTab === "reviews" && (
              <div className="profile-reviews">
                <div className="profile-empty">
                  <p>No reviews yet</p>
                </div>
              </div>
            )}

            {activeTab === "about" && (
              <div className="profile-about">
                <div className="about-section">
                  <h4>About {profileData.fullName}</h4>
                  <p>{profileData.bio || "No bio available."}</p>
                  <p>Joined {timeAgo(profileData.createdAt)}</p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Sidebar */}
        <div className="sidebar">
          {!isOwnProfile && (
            <div className="profile-sidebar-actions">
              <Components.ClickButton
                text={isFollowing ? "Following" : "Follow"}
                icon={isFollowing ? <RiUserUnfollowLine /> : <RiUserFollowLine />}
                variant={isFollowing ? "outline" : "primary"}
                onClick={handleFollow}
                size="large"
              />
              {/* <Components.ClickButton
                text="Message"
                icon={<RiMessageLine />}
                variant="outline"
                onClick={handleMessage}
                size="large"
              /> */}
            </div>
          )}
          
          {isOwnProfile && (
            <Components.UpgradeWidget
              title="Upgrade Your Plan"
              text="Get more features and visibility with a premium plan!"
              onClick={handleUpgrade}
            />
          )}
        </div>
      </div>
    </Components.PageSetup>
  );
};

export default Profile;
